import { Suspense } from "react";
import "./App.css";
import HomePage from "./pages/HomePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Cart from "./pages/Cart";
import Category from "./pages/Category";
import Success from "./pages/Success";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5FD6D1", // Example: green color
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "custom-button" }, // Define the variant
          style: {
            backgroundImage: "linear-gradient(-150deg, #1ab394, #1a91ae)",
            color: "#FFFFFF", // Set button font color to white
            "&:hover": {
              backgroundImage: "linear-gradient(-150deg, #1a91ae, #1ab394)", // Reverse gradient for hover
            },
          },
        },
      ],
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            color: "#5FD6D1", // Set text color to red
          },
          "& .MuiInputLabel-root": {
            color: "#5FD6D1", // Set label color to red
          },
          "& .MuiFormHelperText-root": {
            color: "#5FD6D1", // Set helper text color to red (if used)
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Suspense fallback={"Loading"}>
          <Routes>
            <Route
              path="/:hotelId/:shopId/:tableId/:tableNumber"
              element={<HomePage />}
            />
            <Route
              path="/cat/:hotelId/:shopId/:tableId/:tableNumber"
              element={<Category />}
            />
            <Route
              path="/cart/:hotelId/:shopId/:tableId/:tableNumber"
              element={<Cart />}
            />
            <Route
              path="/success/:hotelId/:shopId/:tableId/:tableNumber"
              element={<Success />}
            />
            <Route path="/booking/:bookingId" element={<HomePage />} />

            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
